<template>
  <TableBodyRow
    :thead="thead"
    class="combosrowhero gw_table_body_row_hoverable"
    :class="{
      combosrowhero_locked: isLocked,
    }"
    @mouseenter="e => $emit('mouseenter', e)"
    @mousedown="e => $emit('mousedown', e)"
  >
    <TableBodyCell
      thKey="summary_idx"
      class="gw_table_body_cell_sticky"
    >
      <div
        v-if="isLocked"
        class="combosrowhero_icon-lock mdi mdi-lock"
      ></div>
      <!-- {{ item.summary_idx }} -->
      <CardSymbols
        :colorDefault="true"
        :cardsIds="item.id"
        style="--size: 1rem"
      />
    </TableBodyCell>
    <TableBodyCell
      thKey="strategy"
      style="--padding-td: 0"
    >
      <div
        v-if="item.players[0].range"
        class="combosrowhero_strategy graph-horizontal graph-horizontal_full graph-horizontal_hover-dimmed w-100"
      >
        <div
          v-for="(action, idx) in getGroupedSolution(item.solution)"
          :key="`${action.code}_${idx}`"
          class="graph-horizontal_item csst csst_nm"
          :class="action.css_class"
          :style="`width: ${action.strategy * 100}%; ${useHex ? `background:${action.hex}` : ''}`"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
        >
          <div
            class="csst_content f-center text-normal"
            style="position: fixed"
          >
            <div class="circle-bullet circle-bullet_large"></div>
            <div class="clr-white ml-2">
              {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
              <span
                class="pl-1"
                v-html="getBetHtml({ showBetsIn, a: action })"
              ></span>
            </div>
            <div class="pl-3 clr-white">{{ numFixedUnit(action.strategy * 100, 'strategy') }}%</div>
          </div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell thKey="range">
      {{ numFixedUnit(item.players[0].range, 'range') }}
    </TableBodyCell>
    <TableBodyCell thKey="ev">
      <div
        style="line-height: 0.8"
        v-html="
          getEvHtml({
            ...bettingInfo,
            ignoreIcmEvIntercept: true,
            ev: item.players[0].ev,
            player: 'hero',
          })
        "
      />
    </TableBodyCell>
    <TableBodyCell thKey="eq">
      <div v-if="showFlopContent">{{ numFixedUnit(item.players[0].eq * 100, 'eq') }}</div>
    </TableBodyCell>
    <TableBodyCell thKey="eq">
      <div v-if="showFlopContent">{{ numFixedUnit(item.players[0].eqr * 100, 'eqr') }}</div>
    </TableBodyCell>

    <TableBodyCell
      v-for="thKey in hasBlockers ? ['blocker_rate', 'unblocker_rate'] : []"
      :key="thKey"
      :thKey="thKey"
    >
      <div v-if="hasPremiumGameformat">
        <div
          v-if="showFlopContent && item.players[0][thKey] !== -1"
          class="f-center csst csst_nm"
          @click.stop="$store.dispatch('router_set_dialogs', 'blockers-tips-dialog')"
        >
          <i
            class="gw-icon-blocker-big blocker_rate_icon"
            :style="`
              color: ${getBlockerClr(item.players[0][thKey])};

          `"
          ></i>
          {{ numFixedUnit(item.players[0][thKey], thKey) }}

          <div
            class="csst_content csst_content_hoverable cursor-pointer text-smallest text-nowrap clr-primary"
            style="position: absolute; right: 100%"
          >
            <i class="mdi mdi-information mr-1"></i
            ><span class="text-underline text-underline_hover"
              >{{ $t('messages.more_about_blockers') }}
            </span>
          </div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      style="order: 99; --padding-td: 0"
      class="role_spacer"
    >
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import CardSymbols from '@/components/CardSymbols/CardSymbols'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import { getGroupedActions } from '@/helpers/grouping'

export default {
  name: 'CombosTableRowHero',
  components: {
    TableBodyRow,
    TableBodyCell,
    CardSymbols,
  },
  mixins: [table_mix, float_mix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
    hasPremiumGameformat: Boolean,
    hasBlockers: Boolean,
    isLocked: Boolean,
    showFlopContent: Boolean,
    useHex: Boolean,
    showBetsIn: String,
    bettingInfo: { type: Object, default: () => ({}) },
    grouping: String,
  },
  emits: ['mousedown', 'mouseenter'],
  methods: {
    getBlockerClr(num) {
      // 1 - 10
      const idx = (num - 1) * 10
      const color = `var(--clr-eveqeqrbl${idx})`
      return color
    },
    getGroupedSolution(actions) {
      const res = getGroupedActions({
        actions,
        grouping: this.grouping,
        groupValues: ['strategy'],
        raisesFirst: true,
      })
      // console.log(res)
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.combosrowhero {
  &_icon-lock {
    position: absolute;
    top: 0;
    right: 0.5rem;
    // right: -0.5rem;
    // transform: translate(0%, 0%);
    z-index: 8;
    height: 100%;
    // z-index: 99;
    font-size: 0.7rem;
    cursor: pointer;
    // width: 1.5rem;
    // height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: rgba(0, 0, 0, 0.33);
    // border-bottom-left-radius: 4px;
  }
}
.blocker_rate_icon {
  font-size: 1.5rem;
  padding-right: 0.25rem;
  position: relative;
  top: 0.075rem;
  line-height: 1;
}
</style>